import { restAxios } from './httpClient';

export const getUnitsOfMeasurement = () => {
	return restAxios.get('/system/units-of-measurement');
};

export const createUnitOfMeasurement = (body) => {
	return restAxios.post('/system/units-of-measurement', body);
};
